// src/api/modules/InquiriesApi.js

import Methods from "../methods";

const createInquiries = (context, payload) => {
  const url = "inquiries/bulk";
  return Methods.doPost(context, url, payload, null);
};

const listByClient = (context, idClient) => {
  const url = `inquiries/client/${idClient}`;
  return Methods.doGet(context, url);
};

const cancelInquiry = (context, id) => {
  const url = `inquiries/${id}`;
  return Methods.doDelete(context, url);
};

export default {
  createInquiries,
  listByClient,
  cancelInquiry
};



// WEBPACK FOOTER //
// ./src/api/modules/InquiriesApi.js